exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user-profile[data-v-79358504]{background-color:rgba(34,37,44,.9);text-align:center\n}\n.profile-avatar[data-v-79358504]{border:2px solid #fff;width:21px;height:21px;overflow:hidden;border-radius:50%;margin-right:5px;max-width:100%\n}\n.profile-background[data-v-79358504]{background-color:silver\n}\n.cropper[data-v-79358504]{max-height:350px;width:100%;background-color:#ddd\n}", ""]);

// exports
